import React, { useEffect, useState } from "react";
import { AiFillFacebook, AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { useParams } from "react-router-dom";
import { apiURL } from "../api";

function Post() {
  const params = useParams();
  const [postData, setPostData] = useState([]);

  useEffect(() => {
    const getPost = async () => {
      const singlePost = await fetch(`${apiURL}/posts/${params.id}`);
      const post = await singlePost.json();
      setPostData(post);
    };
    getPost();
  }, [params.id]);
  return (
    <>
      {postData.map((post) => {
        const imageArray = new Uint8Array(post.image.data.data);
        let str = "";
        for (let i = 0; i < imageArray.length; i++) {
          str += String.fromCharCode(imageArray[i]);
        }
        const base64String = btoa(str);
        const encodedImage = `data:mimeType;base64,${base64String}`;
        return (
          <div className="w-[88%] mx-auto text-center flex flex-col justify-center items-center pt-10 pb-10">
            <h1 className="font-primary text-3xl pb-5">{post.title}</h1>
            <img
              src={encodedImage}
              alt="post"
              className="h-64 w-full object-contain"
            />

            <p className="pt-5">{post.description}</p>
            <div className="flex pt-5 w-32 justify-between">
              <AiFillFacebook size="30" color="blue" />
              <AiFillYoutube size="30" color="red" />
              <AiFillInstagram size="30" color="darkpink" />
            </div>
          </div>
        );
      })}
    </>
  );
}

export default Post;
